import { z } from "zod";

export const FigmaComponentPropertyType = z.enum(["Boolean", "InstanceSwap", "Variant", "Text"]);

//
// Definitions
//

export const FigmaComponentPropertyOrigin = z.object({
  id: z.string(),
});

const FigmaComponentPropertyBase = z.object({
  id: z.string(),
  name: z.string(),
});

export const FigmaComponentInstancePreview = z.object({
  componentName: z.string(),
  componentSetName: z.string().optional(),
  isRemote: z.boolean(),
});

export const FigmaComponentBooleanProperty = FigmaComponentPropertyBase.extend({
  type: z.literal(FigmaComponentPropertyType.enum.Boolean),
  defaultValue: z.boolean(),
});

export const FigmaComponentInstanceSwapProperty = FigmaComponentPropertyBase.extend({
  type: z.literal(FigmaComponentPropertyType.enum.InstanceSwap),
  defaultValue: z.string(),
  defaultValuePreview: FigmaComponentInstancePreview.optional(),
});

export const FigmaComponentVariantProperty = FigmaComponentPropertyBase.extend({
  type: z.literal(FigmaComponentPropertyType.enum.Variant),
  defaultValue: z.string(),
  options: z.array(z.string()),
});

export const FigmaComponentTextProperty = FigmaComponentPropertyBase.extend({
  type: z.literal(FigmaComponentPropertyType.enum.Text),
  id: z.string(),
  defaultValue: z.string(),
});

export const FigmaComponentProperty = z.discriminatedUnion("type", [
  FigmaComponentBooleanProperty,
  FigmaComponentInstanceSwapProperty,
  FigmaComponentTextProperty,
  FigmaComponentVariantProperty,
]);

export const FigmaComponentPropertyMap = z.record(z.string(), FigmaComponentProperty);

export type FigmaComponentInstancePreview = z.infer<typeof FigmaComponentInstancePreview>;
export type FigmaComponentPropertyType = z.infer<typeof FigmaComponentPropertyType>;
export type FigmaComponentBooleanProperty = z.infer<typeof FigmaComponentBooleanProperty>;
export type FigmaComponentInstanceSwapProperty = z.infer<typeof FigmaComponentInstanceSwapProperty>;
export type FigmaComponentVariantProperty = z.infer<typeof FigmaComponentVariantProperty>;
export type FigmaComponentTextProperty = z.infer<typeof FigmaComponentTextProperty>;
export type FigmaComponentProperty = z.infer<typeof FigmaComponentProperty>;
export type FigmaComponentPropertyMap = z.infer<typeof FigmaComponentPropertyMap>;
